import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { simCardSelector } from "../../selectors/simcards";
import { gpsSelector } from "../../selectors/gps";
import { getTypingSimcardsRequest, setStateSimcards, getSimcardsStatusesRequest } from "../../actions/simcards";
import AutoCompleteUsers from "./AutoCompleteSimcard";

const mapStateToProps = createStructuredSelector({
    sicmards: simCardSelector,
    gps: gpsSelector,
});
const mapDispatchToProps = {
    getTypingSimcardsRequest,
    setStateSimcards,
    getSimcardsStatusesRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(AutoCompleteUsers);
